import React from 'react';
import { hasValidKey } from '../utils/helpers';


export const EmptyHeadshotSvg = ({ height = 56, width = 56 }) => (
  <svg width={width} height={height} viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_37705_37394)">
      <path d="M105.688 105.5H0.713257V0.5H105.688V105.5Z" fill="white" />
      <path
        d="M104.968 95.6723C104.968 95.6723 105.063 93.7647 99.0542 91.093L70.4389 77.3543C70.4389 77.3543 66.4563 74.8997 66.2423 71.5343C66.2423 71.5343 65.479 62.852 65.9562 61.9934C65.9562 61.9934 69.8427 56.0543 70.4149 50.4015C70.4149 50.4015 73.4194 50.9024 73.9203 45.2495C73.9203 45.2495 76.2811 36.8775 73.205 37.8077C73.205 37.8077 74.3497 22.4949 73.205 20.2052C73.205 20.2052 71.81 13.8342 64.1196 9.75814C60.4593 7.81804 54.6113 7.73884 53.2014 7.74949C53.2011 7.74949 53.2008 7.74949 53.2005 7.74949C53.2002 7.74949 53.1999 7.74949 53.1996 7.74949C51.7896 7.73884 45.9416 7.81804 42.2812 9.75814C34.5909 13.8342 33.1958 20.2052 33.1958 20.2052C32.0512 22.4949 33.1958 37.8077 33.1958 37.8077C30.1199 36.8775 32.4806 45.2495 32.4806 45.2495C32.9815 50.9024 35.986 50.4015 35.986 50.4015C36.5583 56.0543 40.4447 61.9934 40.4447 61.9934C40.9219 62.852 40.1586 71.5343 40.1586 71.5343C39.9444 74.8997 35.962 77.3543 35.962 77.3543L7.34677 91.093C1.33767 93.7647 1.43316 95.6723 1.43316 95.6723C0.384235 97.3898 0.769161 105.5 0.769161 105.5H53.2005H105.632C105.632 105.5 106.017 97.3898 104.968 95.6723Z"
        fill="#D4D8DC"
      />
    </g>
    <defs>
      <clipPath id="clip0_37705_37394">
        <rect width="105" height="105" fill="white" transform="translate(0.700195 0.5)" />
      </clipPath>
    </defs>
  </svg>
);


const SpeakerHeadshot = ({ speaker, height = 56, width = 56 }) => (
  <div className="speaker-headshot">
    {hasValidKey(speaker, 'photo') ? (
      <img src={speaker.photo} alt={speaker.full_name} height={height} width={width} className="speaker-headshot__image" />
    ) : (
      <EmptyHeadshotSvg width={width} height={height} />
    )}
  </div>
);

export default SpeakerHeadshot;
